const styles = theme => ({
  addBuyerModal: {
    [theme.breakpoints.up('md')]: {
      width: '90%',
      maxWidth: '840px',
      maxHeight: '90vh',
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      border: 0,
    },
  },
  addBuyerModalHeader: {
    [theme.breakpoints.up('md')]: {
      borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
    },
    [theme.breakpoints.down('sm')]: {
      border: 0,
    },
  },

  modalContent: {
    padding: '24px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 16px 16px 16px',
    },
  },

  errorAlertContainer: {
    width: '100%',
    marginBottom: '16px',
  },

  errorAlertMessage: {
    color: theme.palette.primary.adgmBlack,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      lineHeight: '21px',
    },
  },

  selectBuyerTypeContainer: {
    marginBottom: '24px',
    [theme.breakpoints.down('xs')]: {
      marginBottom: '16px',
    },
  },

  selectBuyerTypeHeading: {
    color: theme.palette.primary.adgmBlack,
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '27px',
  },

  selectBuyerTypeFormControl: {
    width: '100%',
    marginTop: '16px',
  },
  selectBuyerTypeRadioGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '24px',

    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      gap: '16px',
    },
  },
  selectBuyerTypeRadioControl: {
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    '& .MuiTypography-root': {
      color: theme.palette.primary.adgmBlack,
      fontSize: '16px',
      fontWeight: 400,
    },

    [theme.breakpoints.down('xs')]: {
      width: '100%',
      flexDirection: 'row-reverse',
      justifyContent: 'space-between',
    },
  },
  selectBuyerTypeRadioButton: {
    borderRadius: 0,
    padding: 0,
    marginRight: '8px',
    '& input:checked + div': {
      color: theme.palette.primary.adgmGreenDark,
    },
  },

  buyerDetailsTitle: {
    color: theme.palette.primary.adgmBlack,
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '27px',
    marginBottom: '24px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '16px',
    },
  },

  fetchBuyerContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    gap: '16px',
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
    },
  },

  fetchBuyerInputContainer: {
    flex: 1,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },

  fetchBuyerDetailsBtn: {
    backgroundColor: theme.palette.primary.adgmBlack,
    color: theme.palette.primary.white,
    padding: '16px 40px',
    marginBottom: '18px',

    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginBottom: 0,
    },

    '&:hover': {
      backgroundColor: theme.palette.primary.adgmBlack,
      color: theme.palette.primary.white,
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.adgmBlack,
      color: theme.palette.primary.white,
    },

    '& span': {
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '24px',
      textTransform: 'capitalize',
    },
  },

  disabledBtn: {
    backgroundColor: `${theme.palette.primary.black20} !important`,
    color: `${theme.palette.primary.white} !important`,
    border: '0 !important',
  },

  buyerDetails: {
    marginTop: '24px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '16px',
    },
  },

  buyerDetailsContent: {
    padding: 0,
  },

  divider: {
    margin: '24px 0',
    [theme.breakpoints.down('sm')]: {
      margin: '16px 0',
    },
  },

  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      marginTop: '16px',
      justifyContent: 'flex-start',
    },
  },

  footerBtn: {
    minWidth: '138px',
    minHeight: 'auto',
    padding: '16px 24px',
    borderRadius: '4px',
    '& span': {
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '24px',
      textTransform: 'capitalize',
    },
  },
  footerCancelBtn: {
    backgroundColor: theme.palette.primary.white,
    color: theme.palette.primary.adgmBlack,
    border: `1px solid ${theme.palette.primary.adgmBlack}`,

    '&:hover': {
      backgroundColor: theme.palette.primary.white,
      color: theme.palette.primary.adgmBlack,
      border: `1px solid ${theme.palette.primary.adgmBlack}`,
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.white,
      color: theme.palette.primary.adgmBlack,
      border: `1px solid ${theme.palette.primary.adgmBlack}`,
    },
  },
  footerAddBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.white,

    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.white,
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.white,
    },

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
});

export default styles;
